<div class="images-slider-section-container">
<!--  <app-images-scroll-->
<!--    [images]="[-->
<!--          '/app/assets/bg/coach.png',-->
<!--          '/app/assets/bg/coach.png',-->
<!--          ]"-->
<!--    [imagesCards]="[-->
<!--          {-->
<!--            title: 'Главный тренер',-->
<!--            firstText: 'Шведский тренер Тэд Сухконен – известный специалист по технике катания и работе с клюшкой и шайбой. ',-->
<!--            secondText: 'В своей тренерской карьере он успел поработать в Федерациях хоккея США и Германии, в сборной Норвегии, в клубах «Амбри-Пиотта» (Швейцария), «Комет», «Лоренског» (оба – Норвегия).',-->
<!--          },-->
<!--          {-->
<!--            title: 'Тренер по ОФП',-->
<!--            firstText: 'Шведский тренер Тэд Сухконен – известный специалист по технике катания и работе с клюшкой и шайбой. ',-->
<!--            secondText: 'В своей тренерской карьере он успел поработать в Федерациях хоккея США и Германии, в сборной Норвегии, в клубах «Амбри-Пиотта» (Швейцария), «Комет», «Лоренског» (оба – Норвегия).',-->
<!--          },-->
<!--        ]"-->
<!--  />-->
  <app-images-scroll
    [imagesCards]="imagesCards"
  />
</div>
